export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6300.b959a944.jpg";